module.exports = __webpack_public_path__ + "img/zj_ico.8f003aa8.png";